import { render, staticRenderFns } from "./InvoiceAttachmentsModal.vue?vue&type=template&id=799b5047&scoped=true&"
import script from "./InvoiceAttachmentsModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceAttachmentsModal.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceAttachmentsModal.vue?vue&type=style&index=0&id=799b5047&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799b5047",
  null
  
)

export default component.exports